import { JsonConverter } from '../JsonConverter'

export class RespuestaSecundaria implements JsonConverter {

  private _id: string
  private _texto: string
  private _indice: number
  private _idSiguiente: string
  
  constructor(id: string, texto: string, indice: number, idSiguiente: string = null) {
    this._id = id
    this._texto = texto
    this._indice = indice
    this._idSiguiente = idSiguiente
  }

  get id(): string {
    return this._id
  }

  get texto(): string {
    return this._texto
  }

  get indice(): number {
    return this._indice
  }

  get idSiguiente(): string {
    return this._idSiguiente
  }

  toJson(): any {
    return {
      id: this.id,
      texto: this.texto,
      indice: this.indice,
      idSiguiente: this.idSiguiente
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dominio/respuesta-secundaria.ts